import React, { FC } from 'react';

import { Button } from '@vimeo/bokeh';

type Props = {
  onClick: () => void;
  href: string;
  text: string;
};

const LinkCTA: FC<Props> = (props: Props) => {
  const { href, onClick, text } = props;
  return (
    <a href={href} onClick={onClick}>
      <Button size="sm" variant="tertiary" color="blue.500" borderColor="blue.500">
        {text}
      </Button>
    </a>
  );
};

export default LinkCTA;
